import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=6f237b2c&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=6f237b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f237b2c",
  null
  
)

export default component.exports